import React, { FC, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { FaRegCopy } from 'react-icons/fa';
import styled from 'styled-components';
import { fadeInAndUp } from '../../../constants/keyframes/fades';
import { inputStyles } from '../../base/forms/input';

const StyledWrapper = styled.div`
	position: relative;

	svg {
		color: ${({ theme }) => theme.colors.textColor};
		position: absolute;
		right: 1rem;
		top: 1.6rem;
		&:hover {
			cursor: pointer;
		}
	}
`;

export const ShipmentIdInput = styled.input`
	${inputStyles}
`;

const StyledCopyText = styled.div`
	position: absolute;
	right: 0;
	top: -2.5rem;
	color: ${({ theme }) => theme.colors.secondary};
	opacity: 1;
	animation: ${fadeInAndUp} 150ms ease forwards;
`;

interface Props {
	value: string | number;
}

const ReadOnlyValue: FC<Props> = ({ value }) => {
	const { t } = useTranslation('registerShipment');
	const [copiedText, setCopiedText] = useState('');
	const numberRef = useRef(null);

	const onClick = () => {
		numberRef.current.select();
		document.execCommand('copy');
		setCopiedText(t('step-receipt.text-copied'));
	};

	return (
		<StyledWrapper>
			<ShipmentIdInput type="text" value={value} readOnly ref={numberRef} />
			<FaRegCopy onClick={onClick} />
			{copiedText.length > 0 && <StyledCopyText>{copiedText}</StyledCopyText>}
		</StyledWrapper>
	);
};

export default ReadOnlyValue;
